import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=0b774fd8&scoped=true"
import script from "./DocumentView.vue?vue&type=script&lang=js"
export * from "./DocumentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b774fd8",
  null
  
)

export default component.exports